import { call, put, takeEvery } from "redux-saga/effects"
import {  UPDATE_OLD_USER_PASSWORD } from "./constants"

import {
  setSuccessMessage,
  setErrorMessage,
  removeErrorMessage,
  removeSuccessMessage,
} from "Containers/Messages/actions"

import {
  responseTypeIsError,
  responseTypeIsSuccess,
  manageErrorGenerator,
  manageSuccessGenerator,
} from "Containers/App/saga"

// Utils
import { postCors } from "Utils/rulesCors"
import { config } from "Utils/config"
import request from "Utils/request"

function* updatePasswordSaga({ payload }) {
  const requestURL = `${config?.APOLLO_SERVER_URL}/login/updatepassword`

  try {
    const response = yield call(request, requestURL, postCors({ ...payload }))

    if (responseTypeIsError(response)) {
      yield call(manageErrorGenerator, { response, showMessageToUser: true })
    } else if (responseTypeIsSuccess(response)) {
      yield call(manageSuccessGenerator, { response, showMessageToUser: true })
    }
  } catch (err) {
    console.error(`[route] => /login/updatepassword/ => ERROR => `, err)
    yield put(setErrorMessage(err))
  }
}

// function* createNewPasswordSaga({ payload }) {
//   const { API_URL } = config
//   var requestURL = "/user/createNewpassword"
//   try {
//     const specificHeaders = { token: token }

//     const response = yield call(request, requestURL, postCors({ ...payload, specificHeaders }))
//     if (responseTypeIsError(response))
//       yield call(manageErrorGenerator, { response, showMessageToUser: true })
//     else if (responseTypeIsSuccess(response)) {
//       yield call(manageSuccessGenerator, { response, showMessageToUser: true })
//     }
//   } catch (err) {
//     console.error(`[route] => ${mainUrl} => ERROR => `, err)
//     yield put(setErrorMessage(err))
//   }
// }

function* newPasswordSaga() {
  yield takeEvery(UPDATE_OLD_USER_PASSWORD, updatePasswordSaga)
}

export default newPasswordSaga
